/*
 * Lunabee — Premium cart-separation guard.
 * Keeps premium and non-premium ("daily") products from being mixed in one
 * Shopify cart. There is only ONE cart per store, so this enforces the rule in
 * the browser: while the cart holds items of one kind, adds of the other kind
 * are blocked with a prompt to finish or empty the current bag first.
 */
(function () {
  var CFG = window.LB_PREMIUM || {};
  var V_IDS = new Set((CFG.variantIds || []).map(Number));
  var P_IDS = new Set((CFG.productIds || []).map(Number));
  var LABELS = CFG.labels || { premium: 'Premium', daily: 'Daily Wear' };
  var mode = CFG.mode || null; // 'premium' | 'daily' | null (empty cart)
  var lastBlocked = null;

  var _fetch = window.fetch ? window.fetch.bind(window) : null;

  function classify(variantId) { return V_IDS.has(Number(variantId)) ? 'premium' : 'daily'; }

  function collectJson(j, ids) {
    if (!j) return;
    if (Array.isArray(j.items)) { j.items.forEach(function (it) { if (it && it.id != null) ids.push(it.id); }); }
    else if (j.id != null) { ids.push(j.id); }
  }
  function idsFromBody(body) {
    var ids = [];
    try {
      if (!body) return ids;
      if (typeof body === 'string') {
        var t = body.trim();
        if (t.charAt(0) === '{' || t.charAt(0) === '[') { collectJson(JSON.parse(t), ids); }
        else { var p = new URLSearchParams(body); if (p.get('id')) ids.push(p.get('id')); }
      } else if (typeof FormData !== 'undefined' && body instanceof FormData) {
        if (body.get('id')) ids.push(body.get('id'));
      } else if (typeof URLSearchParams !== 'undefined' && body instanceof URLSearchParams) {
        if (body.get('id')) ids.push(body.get('id'));
      } else if (typeof body === 'object') { collectJson(body, ids); }
    } catch (e) {}
    return ids.map(Number).filter(Boolean);
  }

  // Returns the offending kind ('premium'/'daily') if the add conflicts, else null.
  function conflictKind(ids) {
    if (mode == null) return null;
    for (var i = 0; i < ids.length; i++) {
      if (classify(ids[i]) !== mode) return classify(ids[i]);
    }
    return null;
  }

  function isAddUrl(u) { return /\/cart\/add(\.js)?(\?|$)/.test(u || ''); }
  function isCartMutation(u) { return /\/cart\/(add|change|update|clear)(\.js)?/.test(u || ''); }

  function syncMode() {
    if (!_fetch) return Promise.resolve(mode);
    return _fetch('/cart.js', { headers: { 'Accept': 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (c) {
        var m = null;
        (c.items || []).forEach(function (it) {
          if (P_IDS.has(Number(it.product_id)) || V_IDS.has(Number(it.variant_id)) || V_IDS.has(Number(it.id))) m = 'premium';
        });
        if (!m && c.item_count > 0) m = 'daily';
        mode = m;
        return m;
      })
      .catch(function () { return mode; });
  }

  // ---------- toast ----------
  function ensureToast() {
    var el = document.getElementById('lb-prem-toast');
    if (el) return el;
    el = document.createElement('div');
    el.id = 'lb-prem-toast';
    el.setAttribute('role', 'alertdialog');
    el.innerHTML =
      '<div class="lb-prem-toast__card">' +
        '<div class="lb-prem-toast__msg"></div>' +
        '<div class="lb-prem-toast__row">' +
          '<button type="button" class="lb-prem-toast__empty"></button>' +
          '<a class="lb-prem-toast__cart" href="/cart">View bag</a>' +
          '<button type="button" class="lb-prem-toast__close" aria-label="Dismiss">Dismiss</button>' +
        '</div>' +
      '</div>';
    var css = document.createElement('style');
    css.textContent =
      '#lb-prem-toast{position:fixed;left:0;right:0;bottom:0;z-index:2000;display:flex;justify-content:center;padding:16px;pointer-events:none;}' +
      '#lb-prem-toast.is-open{}' +
      '#lb-prem-toast .lb-prem-toast__card{pointer-events:auto;max-width:560px;width:100%;background:#223129;color:#fff;border:1px solid rgba(217,184,119,.5);border-radius:14px;padding:16px 18px;box-shadow:0 20px 50px rgba(0,0,0,.4);transform:translateY(140%);transition:transform .3s cubic-bezier(.22,.61,.36,1);}' +
      '#lb-prem-toast.is-open .lb-prem-toast__card{transform:none;}' +
      '#lb-prem-toast .lb-prem-toast__msg{font:600 14px/1.5 var(--lb-sans,system-ui);margin-bottom:12px;}' +
      '#lb-prem-toast .lb-prem-toast__msg b{color:#d9b877;}' +
      '#lb-prem-toast .lb-prem-toast__row{display:flex;gap:10px;flex-wrap:wrap;align-items:center;}' +
      '#lb-prem-toast .lb-prem-toast__empty{background:#d9b877;color:#1c2a22;border:none;border-radius:30px;padding:10px 18px;font:700 13px var(--lb-sans,system-ui);cursor:pointer;}' +
      '#lb-prem-toast .lb-prem-toast__cart{background:rgba(255,255,255,.14);border:1px solid rgba(255,255,255,.3);border-radius:30px;padding:10px 18px;font:700 13px var(--lb-sans,system-ui);color:#fff;}' +
      '#lb-prem-toast .lb-prem-toast__close{margin-left:auto;background:none;border:none;color:rgba(255,255,255,.7);font:600 13px var(--lb-sans,system-ui);cursor:pointer;text-decoration:underline;}';
    document.head.appendChild(css);
    document.body.appendChild(el);
    el.querySelector('.lb-prem-toast__close').addEventListener('click', hideToast);
    el.querySelector('.lb-prem-toast__empty').addEventListener('click', emptyAndSwitch);
    return el;
  }
  var hideTimer = null;
  function showToast(addKind) {
    var el = ensureToast();
    var from = mode === 'premium' ? LABELS.premium : LABELS.daily;
    var to = addKind === 'premium' ? LABELS.premium : LABELS.daily;
    el.querySelector('.lb-prem-toast__msg').innerHTML =
      'Your bag has <b>' + from + '</b> items. <b>' + to + '</b> is a separate shop — finish or empty your current bag to add ' + to + ' items.';
    var emptyBtn = el.querySelector('.lb-prem-toast__empty');
    emptyBtn.textContent = 'Empty bag & add ' + to;
    void el.offsetWidth;
    el.classList.add('is-open');
    clearTimeout(hideTimer);
    hideTimer = setTimeout(hideToast, 9000);
  }
  function hideToast() { var el = document.getElementById('lb-prem-toast'); if (el) el.classList.remove('is-open'); }

  function emptyAndSwitch() {
    if (!_fetch) { window.location.href = '/cart'; return; }
    _fetch('/cart/clear.js', { method: 'POST', headers: { 'Accept': 'application/json' } })
      .then(function () {
        mode = null;
        var add = lastBlocked;
        if (add && add.items && add.items.length) {
          return _fetch('/cart/add.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
            body: JSON.stringify({ items: add.items })
          });
        }
      })
      .then(function () { return syncMode(); })
      .then(function () {
        hideToast();
        document.dispatchEvent(new Event('cart:refresh'));
        try { document.dispatchEvent(new CustomEvent('cart:updated')); } catch (e) {}
        window.location.reload();
      })
      .catch(function () { window.location.href = '/cart'; });
  }

  function blockedResponse(addKind) {
    var desc = 'Premium and Daily Wear items are kept in separate bags.';
    var payload = JSON.stringify({ status: 422, message: 'Items kept separate', description: desc });
    showToast(addKind);
    if (typeof Response !== 'undefined') {
      return Promise.resolve(new Response(payload, { status: 422, headers: { 'Content-Type': 'application/json' } }));
    }
    return Promise.reject(new Error(desc));
  }

  // ---------- fetch interception ----------
  if (_fetch) {
    window.fetch = function (input, init) {
      try {
        var url = (typeof input === 'string') ? input : (input && input.url) || '';
        var method = (init && init.method) || (input && input.method) || 'GET';
        if (isAddUrl(url) && String(method).toUpperCase() === 'POST') {
          var body = (init && init.body) || (input && input.body);
          var ids = idsFromBody(body);
          var bad = conflictKind(ids);
          if (bad) {
            lastBlocked = { items: ids.map(function (id) { return { id: id, quantity: 1 }; }) };
            return blockedResponse(bad);
          }
        }
      } catch (e) {}
      return _fetch(input, init).then(function (res) {
        try {
          var u = (typeof input === 'string') ? input : (input && input.url) || '';
          if (isCartMutation(u)) syncMode();
        } catch (e) {}
        return res;
      });
    };
  }

  // ---------- XHR fallback ----------
  if (typeof XMLHttpRequest !== 'undefined') {
    var _open = XMLHttpRequest.prototype.open;
    var _send = XMLHttpRequest.prototype.send;
    XMLHttpRequest.prototype.open = function (m, u) { this.__lbUrl = u; this.__lbMethod = m; return _open.apply(this, arguments); };
    XMLHttpRequest.prototype.send = function (body) {
      try {
        if (isAddUrl(this.__lbUrl) && String(this.__lbMethod || 'GET').toUpperCase() === 'POST') {
          var ids = idsFromBody(body);
          var bad = conflictKind(ids);
          if (bad) {
            lastBlocked = { items: ids.map(function (id) { return { id: id, quantity: 1 }; }) };
            showToast(bad);
            var self = this;
            setTimeout(function () { try { self.abort(); } catch (e) {} }, 0);
            return;
          }
        }
        var xhr = this;
        this.addEventListener('load', function () { if (isCartMutation(xhr.__lbUrl)) syncMode(); });
      } catch (e) {}
      return _send.apply(this, arguments);
    };
  }

  // Seed mode from the server on first load (covers stale Liquid mode).
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { syncMode(); });
  } else { syncMode(); }
})();
